import http from '@/libs/http'



// 发送验证码
export const sendVerifyCode = (mobile,regionCode) => {
  let data = new URLSearchParams()
  data.append("mobile", mobile)
  data.append("regionCode",regionCode)
  return http.request({
    url: '/s/account/sendVerifyCode',
    data,
    method: 'post'
  })
}

// 添加帐号
export const register = (mobile, verifyCode, password, wxOpenId, ddUserId) => {
  let data = new URLSearchParams()
  data.append("mobile", mobile)
  data.append("verifyCode", verifyCode)
  data.append("password", password)
  if (wxOpenId != null && wxOpenId != '') {
    data.append("wxOpenId", wxOpenId)
  }
  if (ddUserId != null && ddUserId != '') {
    data.append("ddUserId", ddUserId)
  }

  return http.request({
    url: '/s/account/register',
    data,
    method: 'post'
  })
}



